import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const EnergyStorage: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m257.5 270c-26.19 0-47.5-21.31-47.5-47.5s21.31-47.5 47.5-47.5 47.5 21.31 47.5 47.5-21.31 47.5-47.5 47.5zm0-65c-9.65 0-17.5 7.85-17.5 17.5s7.85 17.5 17.5 17.5 17.5-7.85 17.5-17.5-7.85-17.5-17.5-17.5z' />
    <path d='m300 630h-90v-330h30v300h30v-270h30z' />
    <path d='m450 780v-60s30 0 30 0v30c0 16.57-13.43 30-30 30z' />
    <path d='m660 780v-60s30 0 30 0v30c0 16.57-13.43 30-30 30z' />
    <path d='m362.17 27.91-87.17 182.09-25-15 72.2-152.86c7.11-14.97 25-21.34 39.97-14.23z' />
    <path d='m427.95 386.97-152.95-131.77 21.02-20.21 128.65 109.67c12.59 10.77 14.06 29.71 3.28 42.3z' />
    <path d='m30 256.18 197.68-40.99 3.21 28.98-165.35 35.18c-16.21 3.42-32.12-6.96-35.54-23.17z' />
    <path d='m752.1 690h-364.31l37.3-270h241.62c28.3 0 52.36 19.69 55.96 45.81zm-329.88-30h295.69l-24.97-190.19c-1.55-11.25-12.83-19.81-26.23-19.81h-215.48z' />
    <path d='m507.28 682.55c-.37 0-.74-.01-1.11-.04-8.26-.6-14.47-7.79-13.87-16.05l16.45-225.05c.6-8.26 7.79-14.48 16.05-13.87 8.26.6 14.47 7.79 13.87 16.05l-16.45 225.05c-.58 7.89-7.16 13.91-14.94 13.91z' />
    <path d='m633.28 682.55c-7.84 0-14.43-6.09-14.95-14.02l-14.72-225.05c-.54-8.27 5.72-15.41 13.99-15.95s15.41 5.72 15.95 13.99l14.72 225.05c.54 8.27-5.72 15.41-13.99 15.95-.33.02-.66.03-.99.03z' />
    <path d='m431.4 502.51h277.2v30h-277.2z' />
    <path d='m718.68 610h-296.02c-8.28 0-15-6.72-15-15s6.72-15 15-15h296.02c8.28 0 15 6.72 15 15s-6.72 15-15 15z' />
  </IconBase>
));

EnergyStorage.displayName = 'EnergyStorage';

export default EnergyStorage;
